import styled from 'styled-components';
import LogoInvert from '../assets/images/logo-invert.svg';

export default function Footer() {
  return (
    <Container>
      <Inner>
        <Col>
          <Logo>
            <a
              href="https://game2value.it/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={LogoInvert} alt="Game2Value" />
            </a>
          </Logo>
        </Col>
        <Col>
          <span>
            Game2Value S.r.l. - Piazza della Repubblica, 10 - Milano (MI) -
            P.IVA 14799001004
          </span>
        </Col>
        <Col>
          <Social>
            <a
              href="https://www.linkedin.com/company/game2value"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                id="Linkedin"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  id="Tracciato_74"
                  data-name="Tracciato 74"
                  d="M7.5,3h9A4.5,4.5,0,0,1,21,7.5V16.5A4.5,4.5,0,0,1,16.5,21H7.5A4.5,4.5,0,0,1,3,16.5v-9A4.5,4.5,0,0,1,7.5,3Z"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  fillRule="evenodd"
                />
                <path
                  id="Tracciato_75"
                  data-name="Tracciato 75"
                  d="M8.12,11.1v5.4"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                />
                <g id="Raggruppa_49" data-name="Raggruppa 49">
                  <path
                    id="Tracciato_76"
                    data-name="Tracciato 76"
                    d="M11.719,16.5V13.35a2.25,2.25,0,0,1,2.25-2.25h0a2.25,2.25,0,0,1,2.25,2.25V16.5"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                  />
                  <path
                    id="Tracciato_77"
                    data-name="Tracciato 77"
                    d="M8.118,7.838a.225.225,0,1,0,.226.225.224.224,0,0,0-.226-.225"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                  />
                </g>
                <path
                  id="Tracciato_78"
                  data-name="Tracciato 78"
                  d="M0,0H24V24H0Z"
                  transform="translate(0 24) rotate(-90)"
                  fill="none"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/game2value/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                id="Instagram"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  id="Tracciato_70"
                  data-name="Tracciato 70"
                  d="M7.5,3H16.5A4.5,4.5,0,0,1,21,7.5V16.5A4.5,4.5,0,0,1,16.5,21H7.5A4.5,4.5,0,0,1,3,16.5V7.5A4.5,4.5,0,0,1,7.5,3Z"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  fillRule="evenodd"
                />
                <path
                  id="Tracciato_71"
                  data-name="Tracciato 71"
                  d="M16.949,6.713a.338.338,0,1,0,.338.338.339.339,0,0,0-.338-.338"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                />
                <path
                  id="Tracciato_72"
                  data-name="Tracciato 72"
                  d="M14.546,9.454a3.6,3.6,0,1,1-5.091,0,3.6,3.6,0,0,1,5.091,0"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  fillRule="evenodd"
                />
                <path
                  id="Tracciato_73"
                  data-name="Tracciato 73"
                  d="M0,0H24V24H0Z"
                  transform="translate(0 24) rotate(-90)"
                  fill="none"
                />
              </svg>
            </a>
          </Social>
        </Col>
      </Inner>
    </Container>
  );
}

const Container = styled.footer`
  padding: 0 20px;
  background-color: ${(props) => props.theme.colors.dark950};
`;

const Inner = styled.div`
  width: 100%;
  max-width: ${(props) => props.theme.sizes.mw};
  margin: 0 auto;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${(props) => props.theme.colors.white};
  font-size: 0.85rem;
  flex-wrap: wrap;
`;

const Col = styled.div`
  display: inline-block;

  &:nth-child(2) {
    flex: 1;
    text-align: center;
  }

  & + & {
    margin-left: 1rem;
  }

  span {
    line-height: 1.6;
  }

  @media ${(props) => props.theme.breakpoints.phone} {
    width: 100%;
    display: flex;
    justify-content: center;

    & + & {
      margin-top: 1rem;
      margin-left: 0;
    }
  }
`;

const Logo = styled.div``;
const Social = styled.div`
  a + a {
    margin-left: 0.5rem;
  }
`;
